import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "fixed-bottom",
  style: {"cursor":"pointer"}
}
const _hoisted_2 = { class: "mini-player bg-primary rounded col-12 col-md-12 col-lg-4 col-xl-3 float-end mb-3 me-0 me-xl-3 overflow-hidden z-3 position-relative" }
const _hoisted_3 = { class: "player-content d-flex align-items-center h-100 position-relative" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "track-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_song_card_text = _resolveComponent("song-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "progress-overlay",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('slidebarOpen')))
      }, [
        _createElementVNode("div", {
          class: "progress-fill",
          style: _normalizeStyle(_ctx.updateProgress)
        }, null, 4)
      ]),
      _createElementVNode("div", {
        class: "progress-line",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('slidebarOpen')))
      }, [
        _createElementVNode("div", {
          class: "progress-line-fill",
          style: _normalizeStyle(_ctx.updateProgress)
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.track?.coverUrl && !_ctx.imgError)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.track.coverUrl,
              class: "mini-cover",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('slidebarOpen'))),
              onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imgError = true))
            }, null, 40, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "mini-cover d-flex align-items-center justify-content-center text-white-50",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('slidebarOpen')))
            }, [
              _createVNode(_component_IconComponent, {
                lib: "filoxenia",
                icon: "MusicNote",
                style: {"width":"24px","height":"24px"}
              })
            ])),
        _createElementVNode("div", {
          class: "track-info",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('slidebarOpen')))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_song_card_text, {
              text: _ctx.track.name
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-warning rounded-circle text-white d-flex align-items-center justify-content-center z-2 position-absolute end-0 me-3 play-btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('togglePlayback')))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.isPlaying ? 'bi-pause-fill' : 'bi-play-fill')
          }, null, 2)
        ])
      ])
    ])
  ]))
}